const HomePageEbu = {
    CESU: "/cesu",
    SAP: "/sap",
}

export default HomePageEbu
